import React from "react";
import PlatformAnalyticsExperience from "./PlatformAnalyticsExperience";

/*
 * ShopifyAnalytics — served by the redesigned Platform Analytics Experience
 * (Cross-Platform Analytics design-system adoption). The route, report-link
 * contract, and topline data contract are unchanged; the profile (including
 * the governed Audience Data Synthesis binding) lives in
 * src/platformAnalytics/platformAnalyticsProfiles.js.
 */
export default function ShopifyAnalytics() {
  return <PlatformAnalyticsExperience platformKey="shopify" />;
}
